import React, { memo } from 'react';

import './show-items-select.scss';

const ShowItemsSelect = memo(({ options, wrapClass, change }) => {
  //todo remove mock
  const renderOptions = options || [{ value: 40, text: '40 строк' }];

  return (
    <div className={wrapClass}>
      <select className="select-small" onChange={change}>
        {renderOptions.map((option, i) => (
          <option value={option.value} key={i}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
});

export default ShowItemsSelect;

